import { render, staticRenderFns } from "./audioAnalysis.vue?vue&type=template&id=5cdc72a4&scoped=true"
import script from "./audioAnalysis.vue?vue&type=script&lang=js"
export * from "./audioAnalysis.vue?vue&type=script&lang=js"
import style0 from "./audioAnalysis.vue?vue&type=style&index=0&id=5cdc72a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdc72a4",
  null
  
)

export default component.exports